import React from 'react';
import Navbar from '../components/Navbar';
import Solutions from '../components/Solutions';
import ProblemSolution from '../components/ProblemSolution';
import { CTASection, Footer } from '../components/FooterCTA';
import useReveal from '../hooks/useReveal';

export default function SolutionsPage() {
  useReveal();

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <Solutions />
        <ProblemSolution />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
